var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
export const styles = {
    root: {
        backgroundColor: "#FFFFFF",
        paddingTop: "10px",
        paddingLeft: "10px",
        minWidth: '2100px !important',
    },
    elem: {
        fontFamily: "Segoe UI",
        fontSize: "24px",
    },
    dataGridStyles: {
        root: {
            height: 'auto',
            '.datagrid-class': {
                padding: '15px',
                height: '560px'
            },
            '.ms-DetailsRow-cell': {
                borderRight: '1px solid lightgrey',
                maxWidth: '620px !important',
                minWidth: '140px !important',
                fontWeight: '500'
            },
            '.ms-DetailsHeader-cellTitle': {
                borderRight: '1px solid lightgrey'
            },
            '.ms-DetailsHeader': {
                borderTop: '1px solid lightgrey',
                padding: 0,
            },
            '.ms-GroupHeader-title': {
                fontSize: 14,
                fontWeight: 600
            }
        },
        ['data-item-key=actions']: {
            width: '100px'
        }
    },
    NPChevronStyle: {
        width: '40px',
        height: '48px',
        backgroundColor: 'white',
    },
};
export const headerStyle = {
    root: {
        width: '620px !important',
        selectors: {
            '.ms-DetailsHeader-cellName': {
                fontSize: 19,
                fontWeight: 600,
            },
            '.ms-DetailsHeader-cell': {
                width: '620px'
            }
        },
    },
};
export const NPAggregateRowHeaderStyle = {
    root: {
        paddingTop: 0,
        width: '616px !important',
    },
};
export const NPRowHeaderStyle = {
    root: {
        paddingLeft: '10px',
        marginRight: '353px',
        fontWeight: 600,
        fontSize: '14px'
    },
};
export const NPAggregateRowCellStyle = {
    root: {
        width: '140px !important',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
};
export const weekHeaderStyle = {
    root: {
        width: '140px !important',
        selectors: {
            '.ms-DetailsHeader-cellName': {
                fontSize: 14,
                fontWeight: 600,
                paddingLeft: 10,
            },
        },
    },
};
//# sourceMappingURL=GridComponent.styles.js.map